import { render, staticRenderFns } from "./VUnrestrictCard.vue?vue&type=template&id=8eb94abe&scoped=true"
import script from "./VUnrestrictCard.vue?vue&type=script&lang=js"
export * from "./VUnrestrictCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8eb94abe",
  null
  
)

export default component.exports